import ApiGateway from '../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
/**
 * @function allowedTypesQuery gets ALL of the types listed irrespective of their relationship to the user
 * @param user
 * @param nodeEdgeMapper
 * @returns
 */
const allowedTypesQuery = async function (user, nodeEdgeMapper) {
    const types = process.env.REACT_APP_LESS ? [] : ['AggregationGroup', 'Group', 'Geofence', 'Gateway'];
    const apiRef = 'ConsumerApi';
    debug && console.log('in allowed types with', process.env.REACT_APP_LESS);
    const promises = process.env.REACT_APP_LESS
        ? []
        : types.map((type) => {
            const params = {
                type: 'SEARCH_BY_TYPE',
                contextObject: undefined,
                includeContextLinkedItems: false,
                items: [
                    {
                        pk: '',
                        sk: '',
                        id: '',
                        type,
                    },
                ],
                limit: 40,
                scanForward: true,
            };
            return ApiGateway.post('/query/', params, apiRef);
        });
    const results = await Promise.all(promises);
    results.forEach((res, i) => {
        debug && console.log('AllowedTypes res', res);
        if (res.data.Items) {
            nodeEdgeMapper.loadItems(res.data.Items);
        }
        res.err && console.log('AllowedTypes query err', res.err);
        debug && console.log('AllowedTypes res', res);
    });
    return nodeEdgeMapper;
};
export { allowedTypesQuery };
